import { defineMessages } from 'react-intl';

export default defineMessages({
  readingQuestion: {
    id: 'app.features.aiCompanion.readingQuestion',
    defaultMessage: 'Reading your question…',
  },
  reviewingResults: {
    id: 'app.features.aiCompanion.reviewingResults',
    defaultMessage: 'Reviewing what I found…',
  },
  threadLoadFailed: {
    id: 'app.features.aiCompanion.threadLoadFailed',
    defaultMessage: "This chat couldn't be opened. Please try again.",
  },
  threadRenameFailed: {
    id: 'app.features.aiCompanion.threadRenameFailed',
    defaultMessage: "This chat couldn't be renamed. Please try again.",
  },
  threadDeleteFailed: {
    id: 'app.features.aiCompanion.threadDeleteFailed',
    defaultMessage: "This chat couldn't be deleted. Please try again.",
  },
  subjectFailed: {
    id: 'app.features.aiCompanion.subjectFailed',
    defaultMessage: "This conversation couldn't be started. Please try again.",
  },
});
